<template>
  <div>
    <h1 class="h3">Filas de Tarefas</h1>
    
    <SGPTabelaComponent
      v-if="listagemDeTarefas.length"
      :filtroText="true"
      :colunas="colunas"
      :dados="listagemDeTarefas"
      aceitaHtml
      somenteLeitura
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPLoadingComponent v-if="loadingPcoTarefas" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moduleReload from '@/common/mixins/module-reload.js'

export default {
  name: "FilasTarefasPage",
  mixins: [moduleReload],

  data() {
    return {
      // Dados removidos pois não são mais necessários
    };
  },

  async created() {
    await this.listarFilasDeTarefas();
  },

  computed: {
    ...mapGetters('filasTarefas', [
      'listaDeFilasTarefas',
      'loadingPcoTarefas'
    ]),

    listagemDeTarefas() {
      return this.listaDeFilasTarefas.map(tarefa => {
        return {
          ...tarefa,
          visualizar: `/workflow/filas-tarefas/${tarefa.id}`,
        };
      });
    },

    colunas() {
      return [
        {
          key: "tarefa",
          label: "Tarefa",
          sortable: true,
        },
        {
          key: "processo",
          label: "Processo",
          sortable: true,
        },
        {
          key: "total",
          label: "Total",
          sortable: true,
        },
        {
          key: "pendentes",
          label: "Pendentes",
          sortable: true,
        },
        {
          key: "interrompidas",
          label: "Interrompidas",
          sortable: true,
        },
        {
          key: "fora_sla",
          label: "Fora SLA",
          sortable: true,
        },
        {
          key: "percentual_fora_sla",
          label: "Fora SLA (%)",
          sortable: true,
        },
        {
          key: 'visualizar',
          label: 'Visualizar'
        },
      ];
    },
  },

  methods: {
    ...mapActions('filasTarefas', ['listarFilasDeTarefas']),

    reloadData() {
      this.listarFilasDeTarefas();
    },
  },
};
</script>
